import LocalizedStrings from 'react-localization';
import en from './en';

const strings = new LocalizedStrings({
  en,
});

export default strings;
